import React from 'react';
import { FacebookShareButton, TwitterShareButton, FacebookIcon, TwitterIcon } from 'react-share';
import { useSelector } from 'react-redux';

export default function ProductShare() {
    const wording = useSelector(app => app.language.wording);

    return (
        <div className='socials-share clearfix'>
            <div style={{ display: 'flex' }}>
                <span>{`${wording.productPage.product.share}:`}</span>
                <FacebookShareButton url={window.location.href} className='pointer'>
                    <FacebookIcon size={32} round={true} />
                </FacebookShareButton>
                <div style={{ width: 8 }} />
                <TwitterShareButton url={window.location.href} className='pointer'>
                    <TwitterIcon size={32} round={true} />
                </TwitterShareButton>
            </div>
        </div>
    );
}
